'use client';
import React from 'react';
import { X, ExternalLink, Tag, ShoppingBag } from 'lucide-react';
import type { LookbookTag } from './FeedList';

interface Props {
  tag: LookbookTag;
  onClose: () => void;
}

export default function ProductModal({ tag, onClose }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4 bg-black/50 backdrop-blur-sm fade-in"
      onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="bg-white rounded-2xl border border-cream-300 shadow-2xl w-full max-w-sm slide-up">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-cream-200">
          <div className="flex items-center gap-2">
            <Tag size={15} className="text-gold-500" />
            <span className="text-sm font-semibold text-charcoal-900">Tagged Item</span>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-cream-200 text-charcoal-400 transition-colors">
            <X size={16} />
          </button>
        </div>

        {/* Content */}
        <div className="p-5">
          <div className="flex items-start gap-4 mb-5">
            <div className="w-16 h-16 bg-cream-200 rounded-xl flex items-center justify-center shrink-0">
              <ShoppingBag size={24} className="text-charcoal-400" />
            </div>
            <div className="flex-1">
              <p className="text-xs font-semibold text-gold-500 uppercase tracking-wide mb-0.5">{tag.brand}</p>
              <h3 className="font-editorial text-lg font-semibold text-charcoal-900 leading-tight">{tag.item_name}</h3>
              {tag.price && (
                <p className="text-xl font-bold text-charcoal-900 mt-1">{tag.price}</p>
              )}
            </div>
          </div>

          {tag.product_url ? (
            <a href={tag.product_url} target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 w-full py-3 bg-charcoal-900 text-white rounded-xl text-sm font-semibold hover:bg-charcoal-800 active:scale-[0.98] transition-all duration-150">
              <ExternalLink size={15} />
              Shop Now
            </a>
          ) : (
            <div className="flex items-center justify-center gap-2 w-full py-3 bg-cream-200 text-charcoal-500 rounded-xl text-sm font-medium">
              No link available
            </div>
          )}
        </div>
      </div>
    </div>
  );
}